// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__muKur","underline":"Tabs_underline__7SNAh","pills":"Tabs_pills__EqBTe","tab":"Tabs_tab__ZiKbQ","active":"Tabs_active__oW4Ru"};